import { render, staticRenderFns } from "./ClcSalesDasboardDetail.vue?vue&type=template&id=4bcf13fc&"
import script from "./ClcSalesDasboardDetail.vue?vue&type=script&lang=js&"
export * from "./ClcSalesDasboardDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClcSalesDasboardDetail.vue?vue&type=style&index=0&id=4bcf13fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports